import { computed, observable, makeObservable } from 'mobx';
import { getRoot } from 'mobx-easy';
import { UserStatus } from '@bringg/types';
import type { datetime, OnlineStatus } from '@bringg/types';

import BaseDomainObject from '../../core/base-domain-object';
import DriversStore from '../drivers-store';
import { RootStore } from '../../root-store-types';
import UserType from '../../user-types/domain-objects/user-type';

// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
interface Driver extends Bringg.Driver {}

// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
class Driver extends BaseDomainObject<Bringg.Driver> {
	id: number;
	merchant_id: number = null;

	lat: number = null;
	lng: number = null;
	status: OnlineStatus = null;
	sub: UserStatus = null;
	battery: number = null;
	eta_to_home: datetime = null;
	user_type_id: number = null;
	name: string = null;
	service_area_id: number = null;
	active_shift_id: number = null;
	company_id: number = null;
	team_ids: number[] = [];

	constructor(driversStore: DriversStore, driver: Bringg.Driver) {
		super(driversStore, 'users');

		makeObservable(this, {
			lat: observable,
			lng: observable,
			status: observable,
			sub: observable,
			battery: observable,
			eta_to_home: observable,
			user_type_id: observable,
			name: observable,
			userTypeModel: computed,
			asJson: computed
		});

		this.set(driver);
	}

	get userTypeModel(): UserType {
		return getRoot<RootStore>().data.userTypeStore.get(this.user_type_id);
	}

	get asJson(): Partial<Bringg.Driver> {
		return {
			id: this.id,
			merchant_id: this.merchant_id,
			name: this.name,
			status: this.status,
			sub: this.sub,
			lat: this.lat,
			lng: this.lng
		};
	}
}

export default Driver;
